import React, { memo, useCallback, useMemo } from 'react'
import { Modal, Typography } from '@mui/material'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { colors } from 'src/theme'
import Image from 'src/assets/images/failed.png'
import { CancelSmallMinor } from '@shopify/polaris-icons'

interface Props {
  isOpen?: boolean
  onClose(): void
  onGoToDetails(): void
}

const PaymentInProgressModalComponent = ({ isOpen, onClose, onGoToDetails }: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])

  const handleGoToDetails = useCallback(() => {
    onGoToDetails()
    onClose()
  }, [onGoToDetails, onClose])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`flex justify-center items-center backdrop-blur p-4`}
    >
      <div
        data-testid="payments-main-payment-in-progress-modal"
        css={tw`bg-white rounded-lg overflow-hidden w-[330px]`}
      >
        <div css={tw`p-4 flex flex-col`}>
          <div
            data-testid="payments-main-payment-in-progress-close-btn"
            css={tw`p-1 rounded bg-[#EDEDED] h-[28px] hover:bg-[#DAD9E0] active:bg-[#B4AFC0] cursor-pointer self-end`}
            onClick={onClose}
          >
            <CancelSmallMinor width={20} height={20} />
          </div>
          <img src={Image} css={tw`w-[210px] self-center`} />
          <Typography variant="h4" css={tw`text-center mb-0.5`}>
            Settlement In Progress
          </Typography>
          <Typography variant="body2" color={colors.SHADES_GREY_400} css={tw`text-center`}>
            You can't add new settlements right now. Please complete or cancel the current
            settlement process before adding more.
          </Typography>
        </div>
        <div css={tw`px-4 py-3 border-0 border-t border-solid border-[#EDEDED]`}>
          <Button
            size="small"
            color="light"
            className={tw`w-full`}
            onClick={handleGoToDetails}
            data-testid="payments-main-payment-in-progress-go-to-funding-btn"
          >
            Go to funding details
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export const PaymentInProgressModal = memo(PaymentInProgressModalComponent)
